export const panel = {
  appConfig: {
    path: "/api/v1/appConfig",
    method: "GET",
  },
  authenticationOptions: {
    path: "/api/v1/auth/options",
    method: "GET",
  },
  panelLogin: {
    path: "/api/v1/auth/generateCode",
    method: "POST",
  },
  verifyCode: {
    path: "/api/v1/auth/verifyCode",
    method: "POST",
  },
  passwordLogin: {
    path: "/api/v1/auth/password/login",
    method: "POST",
  },
  passwordRegister: {
    path: "/api/v1/auth/password/register",
    method: "POST",
  },
  refreshToken: {
    path: "/api/v1/auth/refreshToken",
    method: "POST",
  },
  companyCategory: {
    path: "/api/v1/companyCategory/selectAll",
    method: "GET",
  },
  supportCompanyModeration: { path: "/api/v1/company/loadForModeration", method: "GET" },
  supportCompanyApprove: { path: "/api/v1/company/activeCompany", method: "POST" },
  supportCompanyReject: { path: "/api/v1/company/inActiveCompany", method: "POST" },
  supportCompanyStatus: { path: "/api/v1/company/changeStatus", method: "POST" },
  supportBlogModeration: { path: "/api/v1/blog/loadForModeration", method: "GET" },
  supportBlogStatus: { path: "/api/v1/blog/changeStatus", method: "POST" },
  supportMediaModeration: { path: "/api/v1/blog/media/loadForModeration", method: "GET" },
  supportMediaStatus: { path: "/api/v1/blog/media/changeStatus", method: "POST" },
  supportModerationHistory: { path: "/api/v1/moderation/history", method: "GET" },
  blogLoadByTypeForAdmin: { path: "/api/v1/blog/loadByTypeForAdmin", method: "GET" },
  supportCategoryCreate: { path: "/api/v1/companyCategory/create", method: "POST" },
  supportCategoryUpdate: { path: "/api/v1/companyCategory/update", method: "POST" },
  supportCategoryManagement: { path: "/api/v1/companyCategory/loadForManagement", method: "GET" },
  supportCategoryDelete: { path: "/api/v1/companyCategory/delete", method: "POST" },
  supportDefaultServiceCreate: { path: "/api/v1/defaultBizService/create", method: "POST" },
  supportDefaultServiceUpdate: { path: "/api/v1/defaultBizService/update", method: "POST" },
  supportDefaultServiceDelete: { path: "/api/v1/defaultBizService/delete", method: "POST" },
  supportCalendarGenerate: { path: "/api/v1/persianCalendar/generatePersianCalendar", method: "POST" },
  supportCalendarRange: { path: "/api/v1/persianCalendar/loadRange", method: "GET" },
  supportCalendarUpdate: { path: "/api/v1/persianCalendar/update", method: "POST" },
  businessReportDashboard: { path: "/api/v1/report/business/dashboard", method: "GET" },
  siteReportDashboard: { path: "/api/v1/report/site/dashboard", method: "GET" },
  businessReportAppointments: { path: "/api/v1/report/business/appointments", method: "GET" },
  businessReportCustomers: { path: "/api/v1/report/business/customers", method: "GET" },
  businessReportServices: { path: "/api/v1/report/business/services", method: "GET" },
  businessReportFinance: { path: "/api/v1/report/business/finance", method: "GET" },
  businessReportCapacity: { path: "/api/v1/report/business/capacity", method: "GET" },
  siteReportAppointments: { path: "/api/v1/report/site/appointments", method: "GET" },
  siteReportUsers: { path: "/api/v1/report/site/users", method: "GET" },
  siteReportCompanies: { path: "/api/v1/report/site/companies", method: "GET" },
  siteReportFinance: { path: "/api/v1/report/site/finance", method: "GET" },
  siteReportCategories: { path: "/api/v1/report/site/market/categories", method: "GET" },
  siteReportGeographies: { path: "/api/v1/report/site/market/geographies", method: "GET" },
  siteReportModeration: { path: "/api/v1/report/site/moderation", method: "GET" },
  createCompany: {
    path: "/api/v1/company/create",
    method: "POST",
  },
  companySelect: {
    path: "/api/v1/company/select",
    method: "GET",
  },
  companyAddFavorite: {
    path: "/api/v1/company/addFavorite",
    method: "POST",
  },
  companyRemoveFavorite: {
    path: "/api/v1/company/removeFavorite",
    method: "POST",
  },
  companyUpdate: {
    path: "/api/v1/company/update",
    method: "POST",
  },
  allCompaniesForEdit: {
    path: "/api/v1/company/allCompaniesForEdit",
    method: "GET",
  },
  saveMedia: {
    path: "/api/v1/company/saveMedia",
    method: "POST",
  },
  updateMedia: {
    path: "/api/v1/company/updateMedia",
    method: "POST",
  },
  deleteBlogMedia: {
    path: "/api/v1/blog/deleteBlogMedia",
    method: "POST",
  },
  unitCreate: {
    path: "/api/v1/unit/create",
    method: "POST",
  },
  allUnitsForEdit: {
    path: "/api/v1/unit/allUnitsForEdit",
    method: "GET",
  },
  allUnitsForEditBizService: {
    path: "/api/v1/unit/allUnitsForEditBizService",
    method: "GET",
  },
  unitDelete: {
    path: "/api/v1/unit/delete",
    method: "POST",
  },
  unitSelect: {
    path: "/api/v1/unit/select",
    method: "GET",
  },
  unitUpdate: {
    path: "/api/v1/unit/update",
    method: "POST",
  },
  unitSaveMedia: {
    path: "/api/v1/unit/saveMedia",
    method: "POST",
  },
  unitUpdateMedia: {
    path: "/api/v1/unit/updateMedia",
    method: "POST",
  },
  bizServiceCreate: {
    path: "/api/v1/bizService/create",
    method: "POST",
  },
  bizServiceSelectAll: {
    path: "/api/v1/bizService/selectAll",
    method: "GET",
  },
  bizServiceSelect: {
    path: "/api/v1/bizService/select",
    method: "GET",
  },
  bizServiceFindByDefaultBizService: {
    path: "/api/v1/bizService/findByDefaultBizService",
    method: "POST",
  },
  loadClientBizServiceById: {
    path: "/api/v1/bizService/loadClientBizServiceById",
    method: "GET",
  },
  bizServiceAddFavorite: {
    path: "/api/v1/bizService/addFavorite",
    method: "POST",
  },
  bizServiceRemoveFavorite: {
    path: "/api/v1/bizService/removeFavorite",
    method: "POST",
  },
  loadBizServiceCommentList: {
    path: "/api/v1/bizService/loadBizServiceCommentList",
    method: "GET",
  },
  bizServiceDelete: {
    path: "/api/v1/bizService/delete",
    method: "POST",
  },
  bizServiceUpdate: {
    path: "/api/v1/bizService/update",
    method: "POST",
  },
  bizServiceSaveMedia: {
    path: "/api/v1/bizService/saveMedia",
    method: "POST",
  },
  bizServiceUpdateMedia: {
    path: "/api/v1/bizService/updateMedia",
    method: "POST",
  },
  loadAllActiveServiceForDiscountEdit: {
    path: "/api/v1/bizService/loadAllActiveServiceForDiscountEdit",
    method: "POST",
  },
  discountCreate: {
    path: "/api/v1/discount/create",
    method: "POST",
  },
  loadAllDiscountByBizService: {
    path: "/api/v1/bizService/loadAllDiscountByBizService",
    method: "POST",
  },
  discountDelete: {
    path: "/api/v1/discount/delete",
    method: "POST",
  },
  generateUnitReserveTime: {
    path: "/api/v1/reserveTime/generateUnitReserveTime",
    method: "POST",
  },
  loadUnitAllReserveTime: {
    path: "/api/v1/reserveTime/loadUnitAllReserveTime",
    method: "POST",
  },
  loadUnitAvailabilityCalendar: { path: "/api/v1/reserveTime/loadUnitAvailabilityCalendar", method: "POST" },
  loadUnitAvailabilityDay: { path: "/api/v1/reserveTime/loadUnitAvailabilityDay", method: "POST" },
  loadClientUnitAllReserveTime: {
    path: "/api/v1/reserveTime/loadClientUnitAllReserveTime",
    method: "POST",
  },
  loadUserByMobileNumber: {
    path: "/api/v1/user/loadUserByMobileNumber",
    method: "GET",
  },
  loadCurrentUserProfile: {
    path: "/api/v1/user/profile",
    method: "GET",
  },
  setInitialPassword: {
    path: "/api/v1/user/password/set",
    method: "POST",
  },
  changePassword: {
    path: "/api/v1/user/password/change",
    method: "POST",
  },
  findOrCreateTemporaryUser: {
    path: "/api/v1/user/findOrCreateTemporaryUser",
    method: "POST",
  },
  preRegisterReserveTimeByUnitAdmin: {
    path: "/api/v1/reserveTime/preRegisterReserveTimeByUnitAdmin",
    method: "POST",
  },
  registerReserveTimeByUnitAdmin: {
    path: "/api/v1/reserveTime/registerReserveTimeByUnitAdmin",
    method: "POST",
  },
  loadReserveTimeByAdminUnit: {
    path: "/api/v1/reserveTime/loadReserveTimeByAdminUnit",
    method: "POST",
  },
  cancelReserveTimeByUnitAdmin: {
    path: "/api/v1/reserveTime/cancelReserveTimeByUnitAdmin",
    method: "POST",
  },
  cancelReserveTimeByClient: {
    path: "/api/v1/reserveTime/cancelReserveTime",
    method: "POST",
  },
  inActiveUnitReserveTime: {
    path: "/api/v1/reserveTime/inActiveUnitReserveTime",
    method: "POST",
  },
  cancelUnitAllReservedTime: {
    path: "/api/v1/reserveTime/cancelUnitAllReservedTime",
    method: "POST",
  },
  reserveTimeAdvancedSearch: {
    path: "/api/v1/reserveTime/reserveTimeAdvancedSearch",
    method: "POST",
  },
  unitAdminCreate: {
    path: "/api/v1/unitAdmin/create",
    method: "POST",
  },
  teamOverview: { path: "/api/v1/team/overview", method: "GET" },
  teamLookup: { path: "/api/v1/team/lookup", method: "GET" },
  teamAdd: { path: "/api/v1/team/add", method: "POST" },
  teamRemove: { path: "/api/v1/team/remove", method: "POST" },
  companyAdminCreate: {
    path: "/api/v1/companyAdmin/create",
    method: "POST",
  },
  unitAdminSelectByCompany: {
    path: "/api/v1/unitAdmin/selectByCompany",
    method: "GET",
  },
  companyAdminSelectByCompany: {
    path: "/api/v1/companyAdmin/selectByCompany",
    method: "GET",
  },
  companyAdminDelete: {
    path: "/api/v1/companyAdmin/delete",
    method: "POST",
  },
  unitAdminDelete: {
    path: "/api/v1/unitAdmin/delete",
    method: "POST",
  },
  loadHomeNearestCompanies: {
    path: "/api/v1/home/loadHomeNearestCompanies",
    method: "GET",
  },
  clientSearch: {
    path: "/api/v1/search/client",
    method: "GET",
  },
  clientSearchSuggestions: {
    path: "/api/v1/search/client/suggestions",
    method: "GET",
  },
  loadHomeSpecialCompanies: {
    path: "/api/v1/home/loadHomeSpecialCompanies",
    method: "GET",
  },
  loadHomeDiscountList: {
    path: "/api/v1/home/loadHomeDiscountList",
    method: "GET",
  },
  loadHomeSpecialServices: {
    path: "/api/v1/home/loadHomeSpecialServices",
    method: "GET",
  },
  loadFavoriteServices: {
    path: "/api/v1/home/loadFavoriteServices",
    method: "GET",
  },
  loadFavoriteCompanies: {
    path: "/api/v1/home/loadFavoriteCompanies",
    method: "GET",
  },
  defaultBizServiceLoadByCategoryId: {
    path: "/api/v1/defaultBizService/loadByCategoryId",
    method: "GET",
  },
  loadHomeCompanies: {
    path: "/api/v1/home/loadHomeCompanies",
    method: "GET",
  },
  defaultBizServiceLoadByCategoryIdList: {
    path: "/api/v1/defaultBizService/loadByCategoryIdList",
    method: "GET",
  },
  loadFilterItem: {
    path: "/api/v1/home/loadFilterItem",
    method: "GET",
  },
  preRegisterReserveTimeByClient: {
    path: "/api/v1/reserveTime/preRegisterReserveTimeByClient",
    method: "POST",
  },
  registerReserveTime: {
    path: "/api/v1/reserveTime/registerReserveTime",
    method: "POST",
  },
  loadAdminReserveTimeListForDetermine: {
    path: "/api/v1/reserveTime/loadAdminReserveTimeListForDetermine",
    method: "POST",
  },
  loadUserReserveTime: {
    path: "/api/v1/reserveTime/loadUserReserveTime",
    method: "POST",
  },
  setReserveTimeUsed: {
    path: "/api/v1/reserveTime/setReserveTimeUsed",
    method: "POST",
  },
  addAdminRateToReserveTime: {
    path: "/api/v1/reserveTime/addAdminRateToReserveTime",
    method: "POST",
  },
  addClientComment: {
    path: "/api/v1/reserveTime/addClientComment",
    method: "POST",
  },
  loadClientReserveTimeComment: {
    path: "/api/v1/reserveTime/loadClientReserveTimeComment",
    method: "POST",
  },
  loadAdminUnitCommentListForReply: {
    path: "/api/v1/reserveTime/loadAdminUnitCommentListForReply",
    method: "POST",
  },
  addAdminCommentReply: {
    path: "/api/v1/reserveTime/addAdminCommentReply",
    method: "POST",
  },
  loadCompanyCommentList: {
    path: "/api/v1/company/loadCompanyCommentList",
    method: "GET",
  },
  blogLoadByType: {
    path: "/api/v1/blog/loadByType",
    method: "GET",
  },
  blogLoadPopular: {
    path: "/api/v1/blog/loadPopular",
    method: "GET",
  },
  registerBlogPostView: {
    path: "/api/v1/blog/registerView",
    method: "POST",
  },
  blogCreate: {
    path: "/api/v1/blog/create",
    method: "POST",
  },
  deleteBlogPost: {
    path: "/api/v1/blog/deleteBlogPost",
    method: "POST",
  },
  createBlogPostComment: {
    path: "/api/v1/blog/createBlogPostComment",
    method: "POST",
  },
  createBlogPostCommentReply: {
    path: "/api/v1/blog/createBlogPostCommentReply",
    method: "POST",
  },
  loadBlogPostCommentList: {
    path: "/api/v1/blog/loadBlogPostCommentList",
    method: "GET",
  },
  loadBlogPostCommentReplyList: {
    path: "/api/v1/blog/loadBlogPostCommentReplyList",
    method: "GET",
  },
}
